// import
import Dashboard from "views/Dashboard/Dashboard";
import UserManagement from "views/Dashboard/UserManagement";
import PackageManagement from "views/Dashboard/PackageManagement";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import {
  LayoutDashboard,
  ContactRound,
  PackageOpen,
  Vault,
  HandCoins,
  MessagesSquare,
  BellDot,
  Star,
  ChartNoAxesCombined,
  HeartHandshake,
  Truck,
  Ruler,
  Coins,
  Car,
  CarIcon,
  CarTaxiFront,
  PiggyBank,
  HouseIcon,
  Factory,
  UserCircle,
  BanknoteIcon,
  CaseLower,
  PiggyBankIcon,
  Percent
} from "lucide-react";
import Chat from "views/Dashboard/Chat";
import SmartLockerManagementPage from "views/Dashboard/SmartLockerManagement";
import TransactionManagement from "views/Dashboard/TransactionManagement";
import NotificationManagement from "views/Dashboard/Notifications";
import RatingManagement from "views/Dashboard/RatingReviewManagement";
import CompartmentPage from "views/Dashboard/SmartLockerManagement/components/CompartmentPage";
import Reports from "views/Dashboard/ReportsAnalytics";
import SupportHelpDesk from "views/Dashboard/Support";
import DeiliveryManagement from "views/Dashboard/DeliveryManagement";
import SizeEstimates from "views/Dashboard/SizeEstimatesManagement";
import DriverCommissionsManagement from "views/Dashboard/DriverCommissionsManagement";
import VehicleManagement from "views/Dashboard/VehicleManagement";
import { FaIndustry } from "react-icons/fa";
import BusinessManagement from "views/Dashboard/BusinessManagement";
import PasswordChange from "views/Auth/PasswordChange";
import Profile from "views/Dashboard/Profile";
import CommissionManagement from "views/Dashboard/DriverCommissionsManagement";
import { ProfileIcon } from "components/Icons/Icons";
import DriverManagement from "views/Dashboard/DriverManagement";
import VerifyOtp from "views/Auth/VerifyOtp.js";
import ManageBankDetailsTab from "views/Dashboard/BankDetailsManagement";
import KilometerManagement from "views/Dashboard/PackagePlanManagement";
import KilometerRatesManagement from "views/Dashboard/KilometerRatesManagement";
import PackageAndRatesTabs from "views/Dashboard/PackagePlansTabs";
import PaymentProofsTable from "views/Dashboard/PaymentProofs";
import ManageCompanySettingsTab from "views/Dashboard/CompanySettingsManagement";
import CompanyBankTabs from "views/Dashboard/CompanyBankTabs";


const dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <LayoutDashboard />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/user-management",
    name: "User Management",
    icon: <ContactRound />,
    component: UserManagement,
    layout: "/admin",
  },
  {
    path: "/size-estimates--management",
    name: "Package Size Mgt",
    icon: <Ruler />,
    component: SizeEstimates,
    layout: "/admin",
  },
  {
    path: "/package-management",
    name: "Package Management",
    icon: <PackageOpen />,
    component: PackageManagement,
    layout: "/admin",
  },
  {
    path: "/commission-management",
    name: "Commission Mgt",
    icon: <Coins />,
    component: CommissionManagement,
    layout: "/admin",
  },
  {
    path: "/delivery-management",
    name: "Delivery Management",
    icon: <Truck />,
    component: DeiliveryManagement,
    layout: "/admin",
  },
  {
    path: "/driver-management",
    name: "Driver Management",
    icon: <UserCircle />,
    component: DriverManagement,
    layout: "/admin",
  },
  {
    path: "/vehicle-management",
    name: "Vehicle Management",
    icon: <CarTaxiFront />,
    component: VehicleManagement,
    layout: "/admin",
  },
  {
    path: "/business-management",
    name: "Business Management",
    icon: <Factory />,
    component: BusinessManagement,
    layout: "/admin",
  },
  // {
  //   path: "/transactions",
  //   name: "Transactions",
  //   icon: <HandCoins />,
  //   component: TransactionManagement,
  //   layout: "/admin",
  // },
  {
    path: "/payment-proofs",
    name: "Payment Proofs",
    icon: <HandCoins />,
    component: PaymentProofsTable,
    layout: "/admin",
  },
  {
    path: "/company-settings",
    name: "Company Settings",
    icon: <Vault />,
    component: CompanyBankTabs,
    layout: "/admin",
  },
  {
    path: "/plan-management",
    name: "Package Plan Mgt",
    icon: <PiggyBankIcon />,
    component: PackageAndRatesTabs,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Notification Mgt.",
    icon: <BellDot />,
    component: NotificationManagement,
    layout: "/admin",
  },
  {
    path: "/messages",
    name: "Messaging",
    icon: <MessagesSquare />,
    component: Chat,
    layout: "/admin",
  },
  {
    path: "/rating",
    name: "Rating & Review",
    icon: <Star />,
    component: RatingManagement,
    layout: "/admin",
  },
  {
    path: "/reports-analytics",
    name: "Reports & Analytics",
    icon: <ChartNoAxesCombined />,
    component: Reports,
    layout: "/admin",
  },
  {
    path: "/support",
    name: "Support & Help Desk",
    icon: <HeartHandshake />,
    component: SupportHelpDesk,
    layout: "/admin",
  },
  {
    path: "/compartments",
    name: "Compartments",
    component: CompartmentPage,
    layout: "/admin",
    visible: false,
  },

  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    layout: "/admin",
    visible: false,
  },

  {
    path: "/signin",
    name: "Sign In",
    component: SignIn,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/change-password",
    name: "Change Password",
    component: PasswordChange,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/verify-otp",
    name: "Verify OTP",
    component: VerifyOtp,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/signup",
    name: "Sign Up",
    component: SignUp,
    layout: "/auth",
    visible: false,
  },
];
export default dashRoutes;
